import React, { FC } from 'react';
import { ContainerInner } from '../../shared/common/ContainerInner';
import { InvoiceOut } from '../../store/api';
import Pagination from '../../shared/common/Pagination';
import NoElementsFound, { NO_ELEMENTS_ORDERS } from '../../shared/components/NoElementsFound';
import FilterBar from '../../shared/common/FilterBar';
import { useOrderListsQuery } from './useOrderListsQuery';
import { downloadInvoice } from '../../api/invoice/downloadInvoice';
import { globalError } from '../../shared/notification/actions';
import { usePaginationAndSortParams } from '../../shared/hooks/usePaginationAndSortParams';
import { useTranslation } from 'react-i18next';
import { OrdersList } from './OrdersList';
import { LoadingWrapper } from '../../shared/components/LoadingWrapper';
import LoadingOverlay from '../../shared/components/LoadingOverlay';

const SORTING = [
    { key: 'orderDateNewToOld', label: 'Order Date: New to Old' },
    { key: 'orderDateOldToNew', label: 'Order Date: Old to New' },
    { key: 'addedToCollectionZA', label: 'Added to Collection' }
];

export const OrdersView: FC = () => {
    const { page, pageSize, sortBy } = usePaginationAndSortParams({
        defaultSortBy: SORTING[0].key,
        defaultPageSize: 50
    });
    const { status, data, error, isLoading } = useOrderListsQuery({ page, pageSize, sortBy });
    const { t } = useTranslation();
    const translatedSorting = SORTING.map(sort => ({
        ...sort,
        label: t(`shop.orders.sortBy.${sort.key}`, sort.label)
    }));

    const onDownloadInvoice = React.useCallback((invoice: InvoiceOut) => {
        downloadInvoice(invoice).catch(error => globalError(error));
    }, []);

    if (status === 'error') {
        return <>Error: {error}</>;
    }

    const { orders, totalCount } = data;

    return (
        <ContainerInner className="orders-view" isLoading={isLoading}>
            {isLoading ? (
                <LoadingWrapper>
                    <LoadingOverlay loading={true} />
                </LoadingWrapper>
            ) : totalCount === 0 ? (
                <NoElementsFound type={NO_ELEMENTS_ORDERS} />
            ) : (
                <div className="bw-wrap medium">
                    <FilterBar
                        sortBy={sortBy}
                        totalProducts={totalCount}
                        pageSize={pageSize}
                        sorting={translatedSorting}
                        isFilterToggleReplaced={true}
                        hideGroupBy={true}
                        hideSelectButtons={true}
                        hideSelectAll={true}
                        hideDisplayType={true}
                    />
                    <OrdersList orders={orders} onDownloadInvoice={onDownloadInvoice} />
                    <div style={{ margin: '40px 0' }}>
                        <Pagination hidden={false} totalItems={totalCount} pageSize={pageSize} />
                    </div>
                </div>
            )}
        </ContainerInner>
    );
};
